import { BACKOFFICE_TOOL_ROUTES, type BackofficeNavItem } from './backoffice-tool-routes';
import { BACKOFFICE_SUBPAGES, type BackofficeSubpage } from './backoffice-subpages';
import { isBackofficeToolActive } from './backoffice-tool-search';

export type BackofficeLocation = {
  /** The nav tool this URL belongs to (a sub-page counts as its parent tool), if any. */
  tool: BackofficeNavItem | undefined;
  /** Set when the URL is a sub-page rather than the tool's own page. */
  subpage: BackofficeSubpage | undefined;
};

/** Where a backoffice URL sits: which tool is current, and whether it is one of the tool's sub-pages. */
export function resolveBackofficeLocation(urlPathname: string, localePrefix: string): BackofficeLocation {
  const subpage = BACKOFFICE_SUBPAGES.find((candidate) =>
    isBackofficeToolActive(candidate.path, urlPathname, localePrefix),
  );
  if (subpage) {
    return { tool: BACKOFFICE_TOOL_ROUTES.find((tool) => tool.path === subpage.parentPath), subpage };
  }
  return {
    tool: BACKOFFICE_TOOL_ROUTES.find((tool) => isBackofficeToolActive(tool.path, urlPathname, localePrefix)),
    subpage: undefined,
  };
}
